import { InputNumberLocalized } from '@components'

import { Flex, Text } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { useFormContext } from '../../../../../../../../hooks'
import { VatDeclarationsDefinePeriodPayoutModalFormSchema } from '../../../../utils/formData'

export const DefinePayoutForm = (): ReactElement => {
  const { t } = useTranslation()
  const { FormItem } = useFormContext<VatDeclarationsDefinePeriodPayoutModalFormSchema>()

  return (
    <Flex justifyContent="space-between">
      <Flex.Item alignSelf="center">
        <Text>{t('vat_declarations.define_payout_modal.form.label')}</Text>
      </Flex.Item>
      <FormItem name="amount" render={({ field }) => <InputNumberLocalized {...field} min={0} />} />
    </Flex>
  )
}
